module.exports = __webpack_public_path__ + "img/thumb_settings_products.3492879a.jpg";